import { ACCESS_FROM, EBU_INFO, PUBLIC_KEY } from './const';
import fetchHelper from './fetch-helper';
import { JSEncrypt } from 'jsencrypt'
import config from '../config';

const ebuHelper = {
  /**
   * 判断是否通过饿了么进入点餐
   */
  isEbuEvn(path = '') {
    let _path = path;
    if (!_path) {
      _path = location.search || '';
    }
    const res = _path.match(/accessFrom=(.*?)(&|$)/);

    const accessFrom = window.sessionStorage ? window.sessionStorage.getItem('ACCESS_FROM') : ''; // 饿企登录标志
    if ((res && Array.isArray(res) && res[1] === ACCESS_FROM.EBU) || accessFrom === ACCESS_FROM.EBU) {
      window.sessionStorage.setItem('ACCESS_FROM', ACCESS_FROM.EBU);
      return true;
    }
    return false;
  },
  login(info) {
    const { shopId, euId } = info;
    const brandId = sessionStorage.getItem('brandId')
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(PUBLIC_KEY);
    const code = encrypt.encrypt(`${brandId}-${shopId}`);

    return fetchHelper
      .get(config.getMobilesByEuid, { shopId, euId })
      .then((data = {}) => {
        const { mobile } = data.result;
        if (mobile) {
          return fetchHelper
            .get(`${config.elmLogin}?shopId=${shopId}&mobile=${mobile}&code=${code}`)
            .then(res => {
              if (res === null || res === '') {
                throw { code: '5001', msg: '登录后返回参数为空' };
              }
              return true
            })
            .catch(err => {
              throw err;
            })
        }
        throw { code: '5001', msg: '登录后返回参数为空' };
      })
      .catch(ex => {
        throw ex;
      });
  },
  /**
   * 判断用户是否登录
   */
  isLogin(info) {
    // const euIdData = window.localStorage && window.localStorage.getItem(EBU_INFO.EBU_EUID);
    // if (euIdData) return Promise.resolve();
    const { shopId, euId } = info;
    return ebuHelper
      .login({ shopId, euId })
      .then(res => {
        if (window.localStorage) {
          localStorage.setItem(EBU_INFO.EBU_EUID, euId);
        }
        return true;
      })
      .catch(ex => {
        throw ex;
      });
  },
}
export default ebuHelper;


// WEBPACK FOOTER //
// ./src/helper/Ebu-app-helper.js